/*
 * product-gallery-fix.js  (cleaned)
 *
 * Keeps the thumbnail -> main-image swap reliable on product pages.
 *
 * NOTE: The previous "snapshot the Zepto canvas into thumbnail 1" feature
 * was REMOVED. It overwrote thumbnail image sources and caused the Zepto
 * preview to appear over / shuffle between thumbnails. Thumbnails now stay
 * as their stable native product images; the live Zepto preview shows in
 * the main image area, which is Zepto's normal behaviour.
 */
(function () {

  function patchThumbnailClicks() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    document.querySelectorAll('.thumbnail-list__item').forEach(function (item) {
      if (item.dataset.glfixBound) return;   // bind exactly once per thumbnail
      item.dataset.glfixBound = '1';

      item.addEventListener('click', function () {
        var targetId = this.dataset.target;
        if (targetId && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(targetId, false);
        }
      }, true); // capture phase, in case another script swallows the bubble
    });
  }

  function init() {
    patchThumbnailClicks();
    setTimeout(patchThumbnailClicks, 800);   // re-bind after Zepto renders
    setTimeout(patchThumbnailClicks, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();